import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageHeader({ eyebrow, title, accent, subtitle, breadcrumbs = [] }) {
    return (
        <section
            className="relative pt-40 pb-20 md:pt-48 md:pb-28 overflow-hidden bg-[#0A1547]"
            data-testid="page-header"
        >
            <div
                className="absolute inset-0 opacity-40 pointer-events-none"
                style={{
                    background:
                        "radial-gradient(ellipse at 80% 20%, rgba(200,160,100,0.18) 0%, transparent 50%), radial-gradient(ellipse at 10% 80%, rgba(60,60,140,0.4) 0%, transparent 55%)",
                }}
            />
            <div className="container-x relative z-10">
                {/* Breadcrumbs */}
                <div className="flex items-center gap-2 text-xs text-[#94A3B8] mb-6">
                    <Link to="/" className="hover:text-[#C8A064] transition-colors">
                        Home
                    </Link>
                    {breadcrumbs.map((b, i) => (
                        <React.Fragment key={i}>
                            <ChevronRight size={12} className="text-[#64748B]" />
                            {b.href ? (
                                <Link to={b.href} className="hover:text-[#C8A064] transition-colors">
                                    {b.label}
                                </Link>
                            ) : (
                                <span className="text-[#C8A064]">{b.label}</span>
                            )}
                        </React.Fragment>
                    ))}
                </div>

                <div className="flex items-center gap-3 mb-6">
                    <span className="h-px w-12 bg-[#C8A064]" />
                    <span className="overline">{eyebrow}</span>
                </div>

                <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#F3F4F6] leading-tight max-w-4xl">
                    {title}{" "}
                    {accent && <em className="text-[#C8A064] not-italic">{accent}</em>}
                </h1>

                {subtitle && (
                    <p className="mt-6 text-[#94A3B8] text-base sm:text-lg leading-relaxed max-w-2xl">
                        {subtitle}
                    </p>
                )}
            </div>
        </section>
    );
}
